"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.PageStyle = exports.DotWrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const PageStyle = (active, primary) => /*#__PURE__*/(0, _react.css)("color:", active ? primary : 'initial', ";&:active,&:hover,&:focus{color:", active ? primary : 'initial', ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:PageStyle;"));
exports.PageStyle = PageStyle;
const Wrapper = exports.Wrapper = /*#__PURE__*/(0, _base.default)("nav", process.env.NODE_ENV === "production" ? {
  target: "eava76v1"
} : {
  target: "eava76v1",
  label: "Wrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1o2oc08",
  styles: "display:grid;grid-column-gap:1em;grid-auto-flow:column;width:min-content"
} : {
  name: "1o2oc08",
  styles: "display:grid;grid-column-gap:1em;grid-auto-flow:column;width:min-content",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const DotWrapper = exports.DotWrapper = /*#__PURE__*/(0, _base.default)("span", process.env.NODE_ENV === "production" ? {
  target: "eava76v0"
} : {
  target: "eava76v0",
  label: "DotWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} : {
  name: "s5xdrg",
  styles: "display:flex;align-items:center",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});